import React, { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function Newsletter() {
    const [email, setEmail] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        const value = email.trim();
        if (!value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            toast.error(
                "Bitte gib eine gültige E-Mail-Adresse ein.",
            );
            return;
        }
        setSubmitting(true);
        setTimeout(() => {
            toast.success(
                "Herzlichen Dank — wir melden uns, sobald es losgeht.",
            );
            setEmail("");
            setSubmitting(false);
        }, 600);
    };

    return (
        <section
            id="newsletter"
            data-testid="newsletter-section"
            className="relative py-24 md:py-32 bg-cream-200"
        >
            <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
                <div className="reveal">
                    <span className="divider-dot mb-8">
                        <span>Sei dabei</span>
                    </span>
                    <h2
                        className="font-serif font-light text-4xl sm:text-5xl text-ink-900 tracking-tight leading-[1.1]"
                        data-testid="newsletter-heading"
                    >
                        Benachrichtige mich
                        <br />
                        <em className="italic text-mauve-500">
                            beim Launch.
                        </em>
                    </h2>
                    <p className="mt-6 text-base md:text-lg text-ink-700 leading-relaxed font-light max-w-xl mx-auto">
                        Trage deine E-Mail ein und erfahre als Erste:r, wenn
                        unsere kleine Welt aus Notizbüchern, Stiften und
                        Geschenken erblüht.
                    </p>
                </div>

                <form
                    action="https://formspree.io/f/xaqvddow"
                    method="POST"
                    data-testid="newsletter-form"
                    className="mt-12 reveal flex flex-col sm:flex-row items-stretch gap-4 sm:gap-0 max-w-xl mx-auto"
                >
                    <input
                        name="email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="deine@email.de"
                        data-testid="newsletter-email-input"
                        required
                        className="flex-1 bg-transparent border-b border-ink-700/30 focus:border-mauve-500 outline-none px-0 py-4 text-center sm:text-left text-base text-ink-900 placeholder:text-ink-500 font-light transition-colors"
                    />
                    <button
                        type="submit"
                        disabled={submitting}
                        data-testid="newsletter-submit-button"
                        className="group inline-flex items-center justify-center gap-3 bg-ink-900 text-cream-50 hover:bg-mauve-500 transition-colors px-8 py-4 text-xs tracking-[0.28em] uppercase font-light disabled:opacity-60"
                    >
                        {submitting ? "Sende…" : "Anmelden"}
                        <ArrowRight
                            size={14}
                            className="transition-transform group-hover:translate-x-1"
                        />
                    </button>
                </form>

                <p className="mt-6 text-xs text-ink-500 font-light tracking-wide reveal">
                    Wir versenden nur die wichtigsten Neuigkeiten — und niemals
                    Werbung.
                </p>
            </div>
        </section>
    );
}
